import api from './api';

export interface Zone {
  id: number;
  name: string;
  description?: string;
  plant_layout: number;
  department?: {
    id: number;
    name: string;
  };
  is_active: boolean;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  color: string;
  opacity: number;
  border_color: string;
  border_style: string;
  capacity?: number;
  created_at: string;
  updated_at: string;
}

export interface ZoneFilters {
  layout?: number;
  is_active?: boolean;
  department?: number;
  search?: string;
}

export class ZoneService {
  private static baseUrl = '/plant-zones';

  static async getZones(filters: ZoneFilters = {}): Promise<Zone[]> {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`${this.baseUrl}/?${params.toString()}`);
    return response.data.results || response.data;
  }

  static async getZone(id: number): Promise<Zone> {
    const response = await api.get(`${this.baseUrl}/${id}/`);
    return response.data;
  }

  static async getZonesByLayout(layoutId: number): Promise<Zone[]> {
    return this.getZones({ layout: layoutId, is_active: true });
  }
}

export default ZoneService;

